import images from "@assets/images";
import { CommonActions, useNavigation } from "@react-navigation/native";
import { DimensionContext } from "@src/DimensionProvider";
import { ImageButton06 } from "components/button";
import React from "react";
import { Image, Linking, Text, View } from "react-native";
import useStyles from "./styles.css";

const SignUpVerificationFailed = () => {
  const styles = useStyles();
  const navigation = useNavigation<any>();
  const { baseWidth } = React.useContext(DimensionContext);

  const onContactUs = () => {
    Linking.openURL("https://fortune8.online/contact-us");
  };

  const onPress = () => {
    navigation.dispatch(
      CommonActions.reset({
        index: 1,
        routes: [
          { name: "SignInOption" },
        ],
      })
    );
  };

  return (
    <View style={styles.viewEmail}>
      <Image
        source={{uri: images["gamezone-logo-horizontal"]}}
        style={styles.smallLogoContainer}
        resizeMode="stretch"
      />
      <View style={[styles.v_congrats]}>
        <Text style={[styles.t_thankyou, 
          { fontFamily: "Roboto-Bold", marginTop: "10%" },
          { fontSize: baseWidth * 0.035}]}>VERIFICATION FAILED</Text>
      </View>
      <View style={{ height: "8%"}} />
      <View style={{flexDirection: "row", alignItems: "center", justifyContent: "center", width: "100%"}}>
        <Image
          resizeMode="stretch"
          source={{uri: images["ic-circle-cross"]}}
          style={{width: "12%", height: "70%", marginRight: "2%"}}
        />
        <Text style={[styles.t_failed, {fontSize: baseWidth * 0.017}]}>
          We were unable to verify your email address.{"\n"}
          Please try again or use a different email address{"\n"}
          to register an account.{"\n\n"}
          Having trouble signing up?{"  "}
          <Text style={styles.t_failed_bold}
            suppressHighlighting onPress={onContactUs}>Contact Us
          </Text>
        </Text>
      </View>
      <ImageButton06
        label="BACK"
        onPress={onPress}
        style={styles.btn_login}
        width={baseWidth * 0.12}
        height={baseWidth * 0.05}
        source={images["btn-big"]}
        labelStyle={{fontSize: baseWidth * 0.012}}
      />
    </View>
  );
};

export default SignUpVerificationFailed;
